import {ref} from "vue";
import {Experience, FlexOffer, FlexOfferPrice, Inventory, MediaImage} from "../../../Services/BookingkitApi/types";
import {IUseWidgetInventory, IUseWidgetInventoryInput} from "../../../Contracts/Composables/IUseWidgetInventory";
import {Locale} from "../../../Constants/locales";


export type ModalWidgetReturnType = {
    experiences: Experience[],
}

export const UseWidgetInventory = (useWidgetInventoryInput: IUseWidgetInventoryInput): IUseWidgetInventory=> {
    const {inventoryService,experienceIds, flexOfferIds, sortOrder, previewToken } = useWidgetInventoryInput;
    const inventory = ref<(Inventory) []>([]);
    const experiences = ref<Experience[]>([]);
    const flexOffers = ref<FlexOffer[]>([]);
    const isLoading = ref<boolean>(false);

    const getExperienceMedia = (experienceId:string): Promise<MediaImage[]> => {
           return  inventoryService.getExperienceMedia(experienceId);

    };

    const setInventory = (list:(Experience | FlexOffer)[]) => {
        inventory.value = list;
    };

    const sortExperiences = (experiencesToSort:(Experience | FlexOffer)[]) => {
        if (!sortOrder) return experiencesToSort;
        return [...experiencesToSort].sort((a, b) => {
            const indexA = sortOrder.indexOf(a.id);
            const indexB = sortOrder.indexOf(b.id);
            return (indexA === -1 ? Number.MAX_VALUE : indexA) -
                (indexB === -1 ? Number.MAX_VALUE : indexB);
        });
    };

    const getInventory = async (): Promise<void> => {
        try {
            isLoading.value = true;
            const [experiencesResult, flexOffersResult] = await Promise.all([
                getExperiences().catch(error => {
                    console.error('Failed to fetch experiences:', error);
                    return [] as Experience[];
                }),
                getFlexOffers().catch(error => {
                    console.error('Failed to fetch flex offers:', error);
                    return [] as FlexOffer[];
                })
            ]);
            inventory.value = [...experiencesResult, ...flexOffersResult];
            inventory.value = inventory.value.filter((inventoryItem) => experienceIds?.includes(inventoryItem.id) || flexOfferIds?.includes(inventoryItem.id));
            inventory.value = sortExperiences(inventory.value);

        } catch (error) {
            console.error('Failed to fetch inventory:', error);
        } finally {
            isLoading.value = false;
        }
    }

    const getExperiences = async (experiencesFilter:string = experienceIds?.join(',') ?? ''): Promise<Experience[]> => {
        try {
            const apiExperiences = await inventoryService.getExperiences(experiencesFilter, undefined, previewToken);
            if (apiExperiences.length && !sortOrder) {
                apiExperiences.sort((a, b) =>
                    experienceIds!.indexOf(a.id) - experienceIds!.indexOf(b.id)
                );
            }
            experiences.value = apiExperiences;
            return apiExperiences;
        } catch (error) {
            throw error;
        }
    };

    const getFlexOfferPrices = async (flexOfferId: string): Promise<FlexOfferPrice[]> => {
        try {
            return await inventoryService.getFlexOfferPrices(flexOfferId);
        } catch (error) {
            throw error;
        }
    };

    const getFlexOffers = async (): Promise<FlexOffer[]> => {
        try {
            const apiFlexOffers = await inventoryService.getFlexOffers();
            flexOffers.value = apiFlexOffers;
            return apiFlexOffers;
        } catch (error) {
            throw error;
        }
    };


    const getExperienceTranslatedProperty = (experience: Experience, property: 'title'|'description', language: Locale) => {
        if (experience.translations) {
            const translation = experience.translations.find((translation) => translation?.locale === language);
            if (translation)
            {
                return translation?.properties?.[property] || experience.title;
            }
        }
        return experience.title;
    }

    return {
        isLoading,
        getExperienceTranslatedProperty,
        getExperienceMedia,
        setInventory,
        getInventory,
        inventory,
        getExperiences,
        getFlexOfferPrices,
    };
};

export default UseWidgetInventory;
